export default {
    dev: {
      apiURL: 'http://localhost:3400'
    },
    stg: {
      apiURL: 'https://api-core-stg.worldify.multiplymii.com/v1'
    },
    prod: {
      apiURL: 'https://api-core.worldify.multiplymii.com/v1'
    },    
    demo:{
      apiURL: 'https://xc2c6httg0.execute-api.us-east-2.amazonaws.com/dev/api/core/v1'
    }

  }
  